// "YYYY-MM-DD" values are calendar dates, not instants: native parsing and
// toISOString() both go through UTC midnight, shifting the day by one in
// most timezones, so both directions must stay in local time.

const DATE_ONLY_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;

export function parseDateOnly(value: unknown): Date | undefined {
  if (value == null || value === "") return undefined;
  const raw = String(value).trim();
  const match = DATE_ONLY_PATTERN.exec(raw);
  if (match) {
    const [, year, month, day] = match.map(Number);
    const date = new Date(year, month - 1, day);
    // The Date constructor rolls invalid parts over (month 13 → January).
    const valid =
      date.getFullYear() === year &&
      date.getMonth() === month - 1 &&
      date.getDate() === day;
    return valid ? date : undefined;
  }
  const date = new Date(raw);
  return isNaN(date.getTime()) ? undefined : date;
}

export function formatDateOnly(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}
